import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { CalendarRange, MapPin, Flag } from "lucide-react";

export default function DelegateEventsPage() {
  const [events, setEvents] = useState([]);
  const [regs, setRegs] = useState([]);

  const load = () => {
    api.get("/events").then((r) => setEvents(r.data));
    api.get("/registrations").then((r) => setRegs(r.data));
  };
  useEffect(() => { load(); }, []);

  const register = async (event_id) => {
    try {
      const { data } = await api.post("/registrations", { event_id });
      await api.post(`/registrations/${data.id}/mock-pay`);
      toast.success("Registered + mock-paid");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't register");
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        <p className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">
          Discover
        </p>
        <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tighter text-[#0A192F]">
          Events you can join
        </h1>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {events.map((ev) => {
            const reg = regs.find((r) => r.event_id === ev.id);
            return (
              <div key={ev.id} className="rounded-xl bg-white border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all" data-testid={`dl-event-${ev.id}`}>
                <div className="h-40 bg-cover bg-center relative" style={{ backgroundImage: `url(${ev.banner_url})` }}>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/80 to-transparent" />
                  <div className="absolute bottom-3 left-4 right-4 text-white">
                    <p className="text-[10px] uppercase tracking-[0.22em] text-[#D4AF37] font-bold">
                      {ev.format}
                    </p>
                    <h3 className="mt-1 text-lg font-semibold">{ev.title}</h3>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-slate-500 flex-wrap">
                    <span className="flex items-center gap-1"><CalendarRange className="h-3.5 w-3.5" />{new Date(ev.start_date).toLocaleDateString()}</span>
                    <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{ev.location}</span>
                    <span className="flex items-center gap-1"><Flag className="h-3.5 w-3.5" />₹{ev.price?.toLocaleString()}</span>
                  </div>
                  <div className="mt-4 flex items-center gap-2">
                    {reg ? (
                      <>
                        <span className="px-3 py-1.5 rounded-full text-[10px] uppercase tracking-[0.18em] font-bold bg-emerald-100 text-emerald-700">
                          {reg.payment_status === "paid" ? "Registered" : reg.payment_status}
                        </span>
                        <Link to={`/events/${ev.slug}`} className="ml-auto text-xs text-[#0F4C81] font-semibold hover:underline">
                          View page →
                        </Link>
                      </>
                    ) : (
                      <Button onClick={() => register(ev.id)} className="bg-[#D4AF37] text-[#0A192F] hover:bg-[#B5952F] font-bold text-xs uppercase tracking-[0.18em]" data-testid={`dl-register-${ev.id}`}>
                        Register (mock pay)
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
